import { reportCaughtError } from '../../utils/clientErrorReporting';
import {
  canReloadForFirestoreAssertion,
  isRecoverableFirestoreAssertion,
  markFirestoreAssertionReload,
} from '../../utils/firestoreAssertionRecovery';

export const CREATE_TEAM_GENERIC_ERROR_MESSAGE = 'Could not create the club. Please refresh and try again.';
export const CREATE_TEAM_FIRESTORE_RECOVERY_MESSAGE = 'Member Nest hit a temporary browser sync issue while creating the club. Refreshing should clear it.';

const FIRESTORE_RECOVERY_RELOAD_DELAY_MS = 1200;

let firestoreRecoveryReloadScheduled = false;

function scheduleFirestoreRecoveryReload() {
  if (firestoreRecoveryReloadScheduled || typeof window === 'undefined') return false;
  if (!canReloadForFirestoreAssertion()) return false;

  firestoreRecoveryReloadScheduled = true;
  markFirestoreAssertionReload();
  window.setTimeout(() => {
    window.location.reload();
  }, FIRESTORE_RECOVERY_RELOAD_DELAY_MS);
  return true;
}

export function getCreateTeamUserError(error, {
  source = 'form.createTeam.submit',
  context = {},
} = {}) {
  const recoverableFirestoreAssertion = isRecoverableFirestoreAssertion(error);

  reportCaughtError(error, {
    source,
    severity: recoverableFirestoreAssertion ? 'warning' : 'error',
    context: {
      flow: 'createClub',
      recoverableFirestoreAssertion,
      ...context,
    },
  });

  if (recoverableFirestoreAssertion) {
    scheduleFirestoreRecoveryReload();
    return CREATE_TEAM_FIRESTORE_RECOVERY_MESSAGE;
  }

  return CREATE_TEAM_GENERIC_ERROR_MESSAGE;
}
